import { StarBoxMultipleIcon } from './StarBoxMultipleIcon';

/**
 * author: Yaroslav Bandura
 * id 9270C3C4-1ADB-4965-9DAE-444F9448B39E
 * name star-box-multiple
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star-box-multiple.svg
 * tags
 */
export const FavoriteBoxMultipleIcon = StarBoxMultipleIcon;
export default FavoriteBoxMultipleIcon